import React, { FC, memo } from 'react';
import { Editor, ItemWrapper, QaRequirementsContent } from './components';
import VariableFieldSelect from 'src/components/common/VariableFieldSelect';
import { FieldFoundResponse } from 'src/api/types';

interface PromptAreaProps {
    value?: string;
    onChange?: (v: string) => void;
}

let tempValue = '';

const PromptArea: FC<PromptAreaProps> = (props) => {
    const { value, onChange } = props;

    const onInput = (e) => {
        const str = e.target.innerHTML;

        onChange?.(str.length && str !== '<br>' ? str : undefined);
        tempValue = str;
    };

    const editorRef = React.useRef<HTMLDivElement>(null);

    const onChooseField = (
        inspectDataSource?: number,
        type?: number,
        field?: FieldFoundResponse
    ) => {
        // 对于语言字段23和客户信息字段16，传参有变化
        const passType = type === 16 ? 5 : type === 23 ? 4 : type;

        const fieldPlaceholder = `<span contenteditable="false" style="color: #1b6dff; user-select: none;">[<span style="display: none">${inspectDataSource}:${passType}:</span>${field?.label}]</span>`;

        if (editorRef.current) {
            const selection = window.getSelection();

            // 锚点：选区的起始点
            let node = selection?.anchorNode;
            while (node && node !== editorRef.current) {
                node = node?.parentNode;
            }

            if (node === editorRef.current) {
                // 选中了编辑器
                if (selection) {
                    const range = selection.getRangeAt(0);
                    range.deleteContents();
                    const spanNode = document.createElement('span');
                    spanNode.innerHTML = fieldPlaceholder ? `&nbsp;${fieldPlaceholder}&nbsp;` : '';
                    range.insertNode(spanNode);
                    range.setStartAfter(spanNode);
                    range.setEndAfter(spanNode);
                    selection.removeAllRanges();
                    selection.addRange(range);
                    editorRef.current?.focus();
                    onInput({ target: editorRef.current });
                }
            } else {
                // 未选中编辑器
                onChange?.(
                    (editorRef.current.innerHTML || '') +
                        `<span>&nbsp;${fieldPlaceholder}&nbsp;</span>`
                );
            }
        }
    };

    return (
        <ItemWrapper>
            <QaRequirementsContent>
                <Editor
                    ref={editorRef}
                    contentEditable
                    onInput={onInput}
                    dangerouslySetInnerHTML={{ __html: value }}
                    key={Math.random().toString()} // 在相同内容时强制刷新
                ></Editor>

                <VariableFieldSelect
                    onChooseField={onChooseField}
                    typeList={[1, 2, 3, 6, 16, 23]}
                />
            </QaRequirementsContent>
        </ItemWrapper>
    );
};

export default memo(PromptArea, (prev, next) => {
    // 防止闪烁
    return tempValue === next.value;
});
